import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useTranslation } from 'react-i18next';
import Modal from '../common/Modal';

const PaymentForm = ({onClose}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isMessageModal, setIsMessageModal] = useState(false);
  const [messageModal, setMessageModal] = useState('');
  const stripe = useStripe();
  const elements = useElements();
  const { t } = useTranslation();


  const handleSubscription = async () => {
    if (!stripe || !elements) return;
    setError(null);
    setLoading(true);
    try {
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
            return_url: window.location.href, // Redirect after payment
        },
        redirect: "if_required"
      });

      if (error) {
        setError(t('subscription.paymentFailed'));
      } else if (paymentIntent.status === "succeeded") {
        setMessageModal(t('subscription.paymentSuccessful'))
        setIsMessageModal(true);
      }
    } catch (err) {
      setError(t('subscription.paymentFailed'));
    }
    setLoading(false);
  };

  const handleCloseForm = () => {
    setIsMessageModal(false);
    onClose(true);
  }

  return (
    <>
    <div className="payment-section">
      <h3>Enter Payment Details</h3>
      <PaymentElement />
      {error && <p className='form-error'>{error}</p>}
      <button className="pay-btn" onClick={handleSubscription} disabled={loading}>
          {loading ? t('subscription.processing') : t('subscription.confirmPayment')}
      </button>
    </div>
    <Modal isOpen={isMessageModal} onClose={handleCloseForm}>
      <p className='modal-message'>{messageModal}</p>
      <button className='action-btn' onClick={handleCloseForm}>
        <i className="fa-solid fa-check"></i>
        {t('profile.ok')}
      </button>
    </Modal>
    </>
  )
    
}

export default PaymentForm;